var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTickIcon = function SvgTickIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40,
    r: 40,
    fill: "#F1F3F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m25.5 41.96 9.356 10.484L50.352 30.76",
    stroke: "#2B8A3E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgTickIcon;